import { listChartTypes, listStatTypes } from './widgets/registry';

function isObject(v) { return v != null && typeof v === 'object' && !Array.isArray(v); }

export function validateConfig(config) {
    const warnings = [];
    if (!isObject(config)) {
        warnings.push('layoutConfig is not an object.');
        return { warnings };
    }
    const maxColumns = Number(config.maxColumns || 0);
    if (!Number.isFinite(maxColumns) || maxColumns <= 0) {
        warnings.push('maxColumns should be a positive number.');
    }
    const sections = Array.isArray(config.sections) ? config.sections : [];
    const ids = new Set();
    const chartTypes = new Set(listChartTypes());
    const statTypes = new Set(listStatTypes());
    const knownContainers = new Set(['group', 'stack']);
    const knownOthers = new Set(['text', 'table', 'component']);

    sections.forEach((s, idx) => {
        const where = `sections[${idx}]`;
        if (!isObject(s)) {
            warnings.push(`${where} is not an object.`);
            return;
        }
        const id = s.id;
        if (typeof id === 'string') {
            if (ids.has(id)) warnings.push(`Duplicate section id '${id}'. Consider unique ids for clarity.`);
            ids.add(id);
        }
        const width = Number(s.width);
        if (!Number.isFinite(width) || width <= 0) warnings.push(`${where}.width should be a positive number.`);
        if (Number.isFinite(width) && Number.isFinite(maxColumns) && width > maxColumns) warnings.push(`${where}.width (${width}) exceeds maxColumns (${maxColumns}). It will be clamped.`);

        const type = s.type;
        const isKnown = chartTypes.has(type) || statTypes.has(type) || knownContainers.has(type) || knownOthers.has(type) || (typeof type === 'string' && (type.endsWith('chart') || type.endsWith('stat-card')));
        if (!isKnown) warnings.push(`${where}.type '${String(type)}' may be unsupported. Ensure it's registered in the widget registry or routed in SectionRenderer.`);

        if (isObject(s.initial)) {
            const { chartid, dashboard_id } = s.initial;
            if ((chartid != null || dashboard_id != null) && (chartid == null || dashboard_id == null)) {
                warnings.push(`${where}.initial should include both chartid and dashboard_id to enable data loading.`);
            }
        }
    });

    return { warnings };
}

export default validateConfig;


